import { DirectionalCount } from "../../../types/Count";
import { Direction } from "../../../types/Direction";
import { orderDirections } from "../models/table-order";
import { TypedCount } from "../../../types/Count";
import { ArrowUpward, Tag } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
    Table,
    TableCell,
    TableHead,
    TableRow,
    TableBody,
    Tooltip,
} from "@mui/material";

const directionalIcons = {
    [Direction.Downstream]: (
        <ArrowUpward sx={{ transform: "rotate(180deg)" }} />
    ),
    [Direction.Upstream]: <ArrowUpward />,
    [Direction.Net]: <Tag />,
    Count: <Tag />,
};

type DeviceCountTableProps =
    | { count: DirectionalCount }
    | { count: { Count: TypedCount } };

export const DeviceCountTable = (props: DeviceCountTableProps) => {
    const { count } = props;
    let sortedDirections: string[];
    let countsObj: Record<string, TypedCount>;

    const theme = useTheme();
    const isXlOrDown = useMediaQuery(theme.breakpoints.down("xl"));

    if ("Count" in count) {
        sortedDirections = ["Count"];
        countsObj = count;
    } else {
        sortedDirections = orderDirections(Object.keys(count) as Direction[]);
        countsObj = count;
    }

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    {sortedDirections.map((direction) => {
                        const icon = (
                            directionalIcons as Record<string, React.ReactNode>
                        )[direction];
                        return (
                            <TableCell
                                key={direction}
                                align="center"
                                sx={{ border: 0 }}
                            >
                                {isXlOrDown && icon ? (
                                    <Tooltip title={direction}>
                                        <span>{icon}</span>
                                    </Tooltip>
                                ) : (
                                    direction
                                )}
                            </TableCell>
                        );
                    })}
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    {sortedDirections.map((direction) => {
                        const counts = countsObj[direction];
                        return (
                            <TableCell
                                key={direction}
                                align="center"
                                sx={{ border: 0 }}
                            >
                                {counts?.Predicted ?? 0}
                            </TableCell>
                        );
                    })}
                </TableRow>
            </TableBody>
        </Table>
    );
};
